import { render, staticRenderFns } from "./SurveyPin.vue?vue&type=template&id=2cba9394&"
import script from "./SurveyPin.vue?vue&type=script&lang=js&"
export * from "./SurveyPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports